module.exports = __webpack_public_path__ + "media/images/athletes/2174-96f409182f86787247536841fd0dc64a.png";